import { Helmet } from 'react-helmet-async';
import { siteMetadata } from '@/config/seo';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteMetadata.siteName,
  url: siteMetadata.siteUrl,
  logo: `${siteMetadata.siteUrl}/turbo-circle.svg`,
};

export const Head = () => {
  return (
    <Helmet>
      <meta
        name="viewport"
        content="viewport-fit=cover, width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      />
      <link rel="icon" href="/favicon.svg" />
      <link rel="apple-touch-icon" href="/favicon.svg" />
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
    </Helmet>
  );
};
